import { useCallback, useState } from 'react';
import { Box, ButtonProps } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Card, EmptyState } from '@/components';
import { templateListSelector } from '@/features/admin/templates/slice';
import { menuSelector } from '@/features/menu/slice';
import { Menu, Template } from '@/types';

interface TemplateGalleryProps {
  type: 'select' | 'edit';
  onSelect?: (templateId: string) => void;
  onEdit?: (templateId: string) => void;
  onDelete?: (templateId: string) => void;
}

const TemplateGallery = ({
  onSelect,
  onEdit,
  onDelete,
  type = 'select',
}: TemplateGalleryProps) => {
  const { menuId } = useParams();
  const [selectTemplate, setSelectTemplate] = useState<string>();
  const menu = useSelector(menuSelector(menuId ?? '')) as Menu;
  const templates = useSelector(templateListSelector) as Template[];

  const handleSelectTemplate = (id: string) => {
    if (onSelect) onSelect(id);
    setSelectTemplate(id);
  };

  const handleEditTemplate = (id: string) => {
    if (onEdit) onEdit(id);
  };

  const handleDeleteTemplate = (id: string) => {
    if (onDelete) onDelete(id);
  };

  const getCardAction = useCallback(
    (templateId: Template['id']) => {
      const actions: ButtonProps[] = [];

      if (type === 'edit') {
        actions.push({
          fullWidth: true,
          size: 'large',
          variant: 'outlined',
          color: 'primary',
          children: 'Eliminar',
          onClick: () => handleDeleteTemplate(templateId),
        });
        actions.push({
          fullWidth: true,
          size: 'large',
          variant: 'contained',
          color: 'primary',
          children: 'Editar',
          onClick: () => handleEditTemplate(templateId),
        });
      } else {
        actions.push({
          fullWidth: true,
          variant: 'contained',
          size: 'large',
          color: 'primary',
          children: 'Elegir',
          onClick: () => handleSelectTemplate(templateId),
          disabled:
            (selectTemplate ? selectTemplate : menu?.template) === templateId,
        });
      }

      return actions;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [menu?.template, selectTemplate, type]
  );

  if (!templates?.length) {
    return <EmptyState title="No se encontrator plantillas disponibles" />;
  }

  return (
    <Box sx={{ padding: 2 }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4 }}>
        {templates.map((t, index) => (
          <Card
            key={`t-${index}`}
            title={t.title}
            image={t.image}
            description={'Lorem ipsum'}
            actions={getCardAction(t.id)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TemplateGallery;
